import React from "react";
import { Typography, Box, Grid } from "@mui/material";
import { SButton } from "@ui/components/buttons/SButton";
import { ArrowLeft2 } from "iconsax-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const UnAuthorizedPage = ({ message, sessionTimeout, }) => {
    const navigate = useNavigate();
    const isAuthenticated = true;
    const onClickHandle = () => {
        if (isAuthenticated) {
            window.history.back();
        }
        else {
            navigate("/event/login");
        }
    };
    const { t } = useTranslation(["form", "validation", "common"]);
    return (React.createElement(Grid, { container: true },
        React.createElement(Grid, { size: 12 },
            React.createElement(Box, { display: "flex", height: "calc(100svh - 68px)", justifyContent: "center", alignItems: "center", bgcolor: "white" },
                React.createElement(Box, { display: "flex", flexDirection: "column", width: "300px", justifyContent: "center", alignItems: "center", flexShrink: 0 },
                    React.createElement(Box, { sx: {
                            width: "300px",
                            height: "300px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            background: `url(/assets/images/image.png) no-repeat center/cover`,
                        } },
                        React.createElement("img", { src: sessionTimeout
                                ? "/assets/images/timer.png"
                                : "/assets/images/disabled.png", width: sessionTimeout ? 64 : 175, height: sessionTimeout ? 64 : 175, alt: "Disabled icon" })),
                    React.createElement(Box, { display: "flex", flexDirection: "column", gap: "32px", alignItems: "center" },
                        React.createElement(Box, { display: "flex", flexDirection: "column", gap: 1, alignItems: "center", justifyContent: "center" },
                            React.createElement(Typography, { variant: "h6", textAlign: "center" }, sessionTimeout
                                ? t("validation:sessionTimedOut")
                                : t("validation:unAuthorized")),
                            React.createElement(Typography, { variant: "subtitle1", color: "textSecondary" }, message)),
                        React.createElement(SButton, { variant: "soft", color: "primary", startIcon: React.createElement(ArrowLeft2, null), onClick: onClickHandle }, sessionTimeout
                            ? t("validation:goToLogin")
                            : t("validation:goBack"))))))));
};
export default UnAuthorizedPage;
